import type { ReactElement } from 'react';
import ComputerIcon from '@mui/icons-material/Computer';
import SportsEsportsIcon from '@mui/icons-material/SportsEsports';
import VrpanoIcon from '@mui/icons-material/Vrpano';
import ChairIcon from '@mui/icons-material/Chair';
import SportsSoccerIcon from '@mui/icons-material/SportsSoccer';
import HeadphonesIcon from '@mui/icons-material/Headphones';
import CategoryIcon from '@mui/icons-material/Category';

export interface CategoryIconInfo {
  icon: ReactElement;
  color: string;
  label: string;
}

const CATEGORY_MAP: Record<string, { Icon: typeof ComputerIcon; color: string; label: string }> = {
  GAMING_PC: { Icon: ComputerIcon, color: '#0EA5E9', label: 'Gaming PC' },
  GAMING_CONSOLE: { Icon: SportsEsportsIcon, color: '#22C55E', label: 'Gaming Console' },
  VR_EQUIPMENT: { Icon: VrpanoIcon, color: '#A855F7', label: 'VR Equipment' },
  FURNITURE: { Icon: ChairIcon, color: '#F59E0B', label: 'Furniture' },
  SPORTS_EQUIPMENT: { Icon: SportsSoccerIcon, color: '#14B8A6', label: 'Sports Equipment' },
  AUDIO_EQUIPMENT: { Icon: HeadphonesIcon, color: '#EF4444', label: 'Audio Equipment' },
  OTHER: { Icon: CategoryIcon, color: '#6B7280', label: 'Other' },
};

const FALLBACK = CATEGORY_MAP['OTHER'];

export function getCategoryIcon(category: string): CategoryIconInfo {
  const entry = CATEGORY_MAP[category] ?? FALLBACK;
  const { Icon, color, label } = entry;
  return { icon: <Icon sx={{ fontSize: 18, color }} />, color, label };
}
